import { Component, Input } from '@angular/core';
import { TechnicalDataDto } from '@vpfa/rest-api/valuation';
import { FeaturesTechnicalDataConfiguration } from '@vpfa/locale';
import { firstVehiclePrice } from '../../../utils/first-vehicle-price';

@Component({
  selector: 'vpfa-full-technical-data-vehicle-information',
  templateUrl: './full-technical-data-vehicle-information.component.html',
  styleUrls: ['./full-technical-data-vehicle-information.component.scss'],
})
export class FullTechnicalDataVehicleInformationComponent {
  @Input() technicalData: TechnicalDataDto;
  @Input() featureConfig: FeaturesTechnicalDataConfiguration;
  @Input() deliveryCountry: string;
  @Input() listPrice: number;

  get firstPrice(): TechnicalDataDto['vehiclePrices'][0] | null {
    return firstVehiclePrice(this.technicalData);
  }
}
